export default {
  services: [],
  service: {}
}



// WEBPACK FOOTER //
// ./src/components/service/store/state.js